import { render, staticRenderFns } from "./VQSelect.vue?vue&type=template&id=99ba4fe4&scoped=true"
import script from "./VQSelect.vue?vue&type=script&lang=js"
export * from "./VQSelect.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ba4fe4",
  null
  
)

export default component.exports